export default __webpack_public_path__ + "static/media/Textile Magzine.19e2deaa.png";